<template>
  <div ref="VChartComWrap" class="VChartComWrap">
    <div ref="EChart" class="VChartCom"></div>
  </div>
</template>

<script>
import * as Echart from 'echarts'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
import _ from 'lodash'
export default {
  props: {
    propValue: {
      type: Object,
      require: true,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    // 监听组件修改的内容，响应式修改数据
    element: {
      deep: true,
      handler() {
        this.render()
      }
    }
  },
  mounted() {
    // 初始化echarts，渲染大小
    this.echart = Echart.init(this.$refs.EChart, null)
    this.render = _.debounce(this.render, 300)
    this.render()
  },
  methods: {
    render() {
      const EChart = this.echart
      const option = this.propValue.option
      if (!this.propValue.option.changeDevicePixelRatio) {
        option.title &&
          (option.title.textStyle.fontSize = changeDevicePixelRatio(
            this.element.style.fontSize || 18
          ))
        if (option.legend) {
          option.legend.itemWidth = changeDevicePixelRatio(
            option.legend.itemWidth || 25
          )
          option.legend.itemHeight = changeDevicePixelRatio(
            option.legend.itemHeight || 14
          )
          option.legend.textStyle.fontSize = changeDevicePixelRatio(12)
        }
        if (option.tooltip) {
          option.tooltip.textStyle = {
            fontSize: changeDevicePixelRatio(14)
          }
          option.tooltip.padding = changeDevicePixelRatio(5)
        }
        if (option.xAxis && option.xAxis instanceof Array) {
          option.xAxis.forEach((element) => {
            element.axisLabel.fontSize = changeDevicePixelRatio(12)
          })
        }
        if (option.yAxis && option.xAxis instanceof Array) {
          option.yAxis.forEach((element) => {
            element.axisLabel.fontSize = changeDevicePixelRatio(12)
          })
        }
      }
      this.propValue.option.changeDevicePixelRatio = true
      // 设置参数
      const config = {
        ...option
      }
      // 更新大小
      this.echart.resize({
        width: this.$refs.VChartComWrap.clientWidth,
        height: this.$refs.VChartComWrap.clientHeight
      })
      // 配置参数
      EChart.setOption(config)
    }
  }
}
</script>

<style lang="scss" scoped>
.VChartComWrap {
  width: 100%;
  height: 100%;
}
.VChartCom {
  width: 100%;
  height: 100%;
}
</style>
